import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramClinicsAddPage } from './program-clinics-add';
import { MatFormFieldModule, MatInputModule, MatSelectModule, MatButtonModule } from '@angular/material';

@NgModule({
  declarations: [
    ProgramClinicsAddPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramClinicsAddPage),
    MatFormFieldModule, MatInputModule, MatSelectModule, MatButtonModule
  ],
})
export class ProgramClinicsAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-clinics-add/program-clinics-add.module.ts